"use strict";

var _interopRequireWildcard = require("/opt/jenkins/workspace/sit-app-client/node_modules/@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("/opt/jenkins/workspace/sit-app-client/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.object.keys");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.regexp.replace");

require("vant/es/toast/style/less");

var _toast = _interopRequireDefault(require("vant/es/toast"));

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.regexp.match");

var _index = require("@/api/index");

var util = _interopRequireWildcard(require("@/utils/util"));

var _wx = require("@/utils/wx");

var _openApp = _interopRequireDefault(require("@/components/open-app"));

var _initJsBridge = _interopRequireDefault(require("@/utils/initJsBridge"));

var _dsbridge = _interopRequireDefault(require("dsbridge"));

var _share = _interopRequireDefault(require("@/components/share"));

var u = navigator.userAgent;
var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; // android终端

var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端

var defaultDetail = {
  Title: '',
  // 标题
  Info_Src: '',
  // 来源
  Issue_date: '',
  // 发布时间
  Contents: '',
  // 内容 包含图片 应该是个html片段
  url: location.href,
  // 当前页面地址
  Url: '' // 附件地址

};
var FILTER_ARTICLE_CONTENT_LIST = ['智通财经APP获悉，', '智通财经APP讯，', '智通财经APP数据显示，', '智通财经APP预告，', '智通财经APP统计，', '【免责申明】股市有风险，入市需谨慎。本资讯不构成投资建议，查阅更多资讯请关注智通财经网(http://www.zhitongcaijing.com/)或者在各大应用商店下载【智通财经】最新APP便捷查看。'];
var FILTER_ARTICLE_TITLE_LIST = ['智通'];
var _default = {
  name: 'Zixun',
  components: {
    share: _share.default,
    OpenApp: _openApp.default
  },
  filters: {
    decimalsToPercent: function decimalsToPercent(number) {
      var result;

      if (typeof number === 'number') {
        result = number > 0 ? "+".concat((number * 100).toFixed(2), "%") : "".concat((number * 100).toFixed(2), "%");
      }

      return result || '--';
    }
  },
  data: function data() {
    return {
      textNodeFlag: false,
      // 是文本节点 默认false
      id: '',
      // 资讯详情id
      source: 'TDX',
      // 资讯供应商类型 默认tdx
      type: '1',
      // 资讯类别 1新闻 | 2公告 | 3概况 | 4财务  为2时需要增加附件?
      market: '',
      // 市场类型：U，美股；H，港股；A，沪深；HUA，所有市场
      detail: Object.assign({}, defaultDetail),
      // 每条资讯详情的信息
      isSkeleton: true,
      // 是否显示骨架屏 默认显示 加载完内容隐藏
      fontSizeType: 'large',
      styleMode: 'light',
      // 系统风格 light亮 dark 深色模式
      recommend: [// 相关推荐
      {
        title: 'BAT们的ToBAT们的ToBAT们的ToBAT们的ToBAT们的ToBAT们的To B投资战：数量，腾讯绝对碾压；金额，阿里大幅领先',
        pic: 'xx.png',
        cTime: '21分钟前',
        author: '腾讯科技',
        id: '1'
      }, {
        title: '阿里组织架构调整的目的之一：把每天50亿流量的“钱袋子”BAT们的ToBAT们的To大萨达大所大',
        pic: 'ww.png',
        cTime: '15:07',
        author: '中国企业家',
        id: '2'
      }],
      tag: '',
      isApp: false,
      isAndroidOrIos: true,
      isIphoneX: false,
      currentLink: location.href,
      stocks: [],
      // 舆情聚焦相关证券
      stockList: [],
      // 中台配置的相关证券列表
      researchStock: [],
      // 研报详情相关证券或中台配置的关联股票
      imgList: [],
      // 富文本图片列表
      previewlist: [] // 预览图片列表

    };
  },
  computed: {
    openAppIsShow: function openAppIsShow() {
      return this.isAndroidOrIos && !this.isApp && !this.isSkeleton;
    },
    isKaisaGlobalPcClient: function isKaisaGlobalPcClient() {
      return util.isKaisaGlobalPcClient();
    },
    bottomPadding: function bottomPadding() {
      var className = '';

      if (this.openAppIsShow && this.isIphoneX) {
        className = 'pb-77';
      } else if (this.openAppIsShow) {
        className = 'pb-65';
      }

      return className;
    }
  },
  watch: {
    '$route': function $route(to, from) {
      this.$router.go(0);
    },
    'detail': function detail() {
      var _this = this;

      this.$nextTick(function () {
        var imageNodes = document.querySelectorAll('[data_src]');
        imageNodes.forEach(function (node) {
          while (node.parentNode) {
            if (node.parentNode.parentNode.getAttribute('class') === 'zixun-detail-content zixun-detail-wrap') {
              node.parentNode.setAttribute('class', 'hide');
              break;
            } else {
              node = node.parentNode;
            }
          }
        });

        if (_this.isTextNode()) {
          _this.textNodeFlag = true;
        }

        if (_this.$refs.zixunDetailWrap.childNodes.length === 1 && !_this.isTextNode()) {
          _this.$refs.zixunDetailWrap.childNodes[0].classList.remove('hide');
        }
      });
    },
    'styleMode': function styleMode(mode) {
      if (mode === 'dark') {
        this.$nextTick(function () {
          document.body.setAttribute('data-theme', 'dark');
        });
      }
    }
  },
  beforeCreate: function beforeCreate() {
    if (this.$route.query.source === 'rrSyncMain') {
      // 研报详情页面更改title
      document.title = '研报摘要';
    }
  },
  created: function created() {
    var _this2 = this;

    // 获取资讯id 和 资讯类型 通达信 | 智通
    var appDetails = (u.match(/zunaerqjth_(\d)+/) || ['unknown'])[0].split('_');
    var appVersion = appDetails.length > 1 ? Number(appDetails[1]) : 0; // App版本号为100，代表1.0.0;以此类推，150代理1.5.0

    this.id = this.$route.query.recId || this.$route.query.articleCode || this.$route.query.reportId;
    this.source = this.$route.query.source || 'TDX';
    this.type = this.$route.query.type || '1'; // 1新闻 | 2公告 需要请求这个

    this.market = this.$route.query.market || ''; // 通达信接口需要根据市场类型来区分公告内容的查询键值

    this.isApp = (0, util.getIsAppClient)();
    this.isIphoneX = (0, util.getIsIphonex)();
    this.recordUserVisitedCount();

    if (!isAndroid && !isiOS) {
      this.isAndroidOrIos = false;
    }

    try {
      var showIcon = this.$route.query.showIcon;

      if ((0, util.getIsAppClient)() && (this.source === 'YQJJ' || showIcon === '1')) {
        if (isAndroid) {
          _dsbridge.default.call('nativeShowChangeFont', {
            showType: '1'
          }, function (response) {
            console.log("nativeShowChangeFont response: ".concat(response));
          });

          _dsbridge.default.call('nativeShowSetting', {
            showType: '0'
          }, function (response) {
            console.log("nativeShowSetting response: ".concat(response));
          });
        }

        if (isiOS) {
          (0, _initJsBridge.default)(function () {
            // 通过JsBridge调用原生方法，写法固定，第一个参数时方法名，第二个参数时传入参数，第三个参数时响应回调
            window.WKWebViewJavascriptBridge.callHandler('nativeShowChangeFont', {
              showType: '1'
            }, function (response) {
              console.log("nativeShowChangeFont response: ".concat(response));
            });
            window.WKWebViewJavascriptBridge.callHandler('nativeShowSetting', {
              showType: '0'
            }, function (response) {
              console.log("nativeShowSetting response: ".concat(response));
            });
          });
        }
      }
    } catch (error) {
      console.log(error);
    }

    if (!this.id) {
      // 没有获取到id
      (0, _toast.default)({
        message: '未获取到id',
        duration: 5 * 1000
      });
    } else {
      var self = this;

      try {
        if ((0, util.getIsAppClient)()) {
          if (isAndroid) {
            _dsbridge.default.call('getFontSize', null, function (response) {
              self.fontSizeType = response;
            });
          }

          if (isiOS) {
            (0, _initJsBridge.default)(function () {
              window.WKWebViewJavascriptBridge.callHandler('getFontSize', null, function (response) {
                self.fontSizeType = response;
              });
              var CanNotCallNativeStyleMode = !!util.getSystemTheme();

              if (appVersion >= 150 && !CanNotCallNativeStyleMode) {
                window.WKWebViewJavascriptBridge.callHandler('nativeStyleMode', null, function (response) {
                  _this2.styleMode = response;
                });
              }
            });
          }
        }

        if (appVersion > 100 && this.source !== 'YQJJ' && (0, util.getIsAppClient)() && isiOS) {
          /**
           * 佳投环球iOS版在初始化WebView的同时请求非舆情聚焦的资讯内容，并在初始化完成后传送给H5端进行渲染，以期加快客户端访问资讯的速度
           * 视性能优化效果再决定是否推广到Android端及舆情聚焦模块
           * 增加对App版本号的判断，以兼容已上线的旧版本APP
           */
          (0, _initJsBridge.default)(function () {
            window.WKWebViewJavascriptBridge.callHandler('getNewsDetails', null, function (data) {
              self.onNewsDetailsLoaded(data);
            });
          });
        } else {
          this.getNewsDetails();
        }
      } catch (error) {
        console.log(error);
        this.getNewsDetails();
      }
    }
  },
  mounted: function mounted() {
    this.init();
  },
  methods: {
    getNewsDetails: function getNewsDetails() {
      var _this3 = this;

      (0, _index.getZixunDetail)(this.id, this.source, this.type, this.market).then(function (data) {
        try {
          _this3.onNewsDetailsLoaded(data);
        } catch (error) {
          console.error(error);
        }
      }).catch(function (error) {
        console.log(error);
        (0, _toast.default)({
          message: '获取新闻资讯内容失败',
          duration: 5 * 1000
        });
      });
    },
    onNewsDetailsLoaded: function onNewsDetailsLoaded(data) {
      var _this4 = this;

      this.isSkeleton = false; // 隐藏骨架屏

      if (this.fontSizeType === 'small') {
        this.decreaseFontSize();
      } else if (this.fontSizeType === 'large') {
        this.recoverFontSize();
      }

      switch (this.source) {
        case 'ZTCJ':
          // 智通财经
          this.detail = this.dataHandleZT(data.body);
          break;

        case 'YQJJ':
          // 舆情聚焦
          this.detail = this.dataHandleYQJJ(data.body);
          break;

        case 'globalNews':
          // 综合资讯（首页改版）
          this.detail = this.dataHandleGlobalNews(data.body);
          break;

        case '7x24':
          // 7 X 24小时
          this.detail = this.dataHandleSevenDays(data.body);
          break;

        case 'rrSyncMain':
          // 研报中心
          this.detail = this.dataHandleResearchCenter(data.body);
          break;

        default:
          // 默认通达信的处理方式
          this.detail = this.dataHandleTDX(data.body);
          break;
      }

      this.detail.Title = (0, util.filterString)(FILTER_ARTICLE_TITLE_LIST, this.detail.Title);
      this.detail.Contents = (0, util.filterString)(FILTER_ARTICLE_CONTENT_LIST, this.detail.Contents);

      if (this.detail.Info_Src !== '汇金智通资讯' && this.detail.Info_Src !== '资讯') {
        this.detail.Contents = (0, util.filterStyleProperty)(this.detail.Contents);
        this.detail.Contents = (0, util.filterEmptyHtmlTag)(this.detail.Contents);
      }

      this.detail.Contents = (0, util.tableTagAddScrollClassName)(this.detail.Contents);
      this.detail.url = location.href;
      (0, _wx.shareConfig)(this.detail.Title, this.detail.Summary); // 调用微信jssdk分享功能
      // 判断是什么环境 只有在app内才显示分享按钮  加载出信息了才显示分享按钮

      this.$nextTick(function () {
        _this4.bindClass();
      });
    },
    isTextNode: function isTextNode() {
      // 文本节点要渲染\n...
      if (this.$refs.zixunDetailWrap.childNodes[0] && this.$refs.zixunDetailWrap.childNodes.length === 1) {
        var textNode = this.$refs.zixunDetailWrap.childNodes[0].nodeType === 3;
        return textNode;
      }
    },
    toDetail: function toDetail(url) {
      // 跳转去附件
      if (util.isKaisaGlobalPcClient()) {
        this.setUrlToKaisaGlobalPcClient(url);
        return;
      }

      window.location = url;
    },
    toPage: function toPage(id) {
      // 进入相关资讯页面
      this.$router.push({
        name: 'zixun',
        query: {
          id: id
        }
      });
    },
    toStock: function toStock(event, id) {
      // 进入相关资讯页面
      if (util.isKaisaGlobalPcClient()) {
        this.$qtBridge.setCode(id);
        return;
      }

      location.href = "".concat(location.protocol, "//").concat(process.env.VUE_APP_BASE_API, "/popular-feelings/#/company-homepage?id=").concat(id);
    },
    toIndividualSharePage: function toIndividualSharePage(stock) {
      if (util.isKaisaGlobalPcClient() && stock.setCode) {
        if (this.source === 'rrSyncMain') {
          // 研报跳转到报价-研报分析页
          this.$qtBridge.onGoToPage(stock.stockCode, 1); // 0:跳转到报价，1：跳转到研报分析页
        } else {
          this.$qtBridge.setCode(stock.stockCode);
        }

        return;
      }

      if (this.isApp && stock.setCode) {
        // 跳转到个股详情页面需要股票名称、股票代码和setCode字段，如果有setCode一定会有其它两个字段
        var params = {
          setCode: stock.setCode,
          stockCode: stock.stockCode,
          stockName: stock.stockName
        };

        if (isiOS) {
          (0, _initJsBridge.default)(function () {
            window.WKWebViewJavascriptBridge.callHandler('nativeToStockDetail', params, function () {});
          });
        } else if (isAndroid) {
          _dsbridge.default.call('nativeToStockDetail', params, function () {});
        }
      }
    },
    toNotice: function toNotice(event, url) {
      // 针对PC端提供的查看公告的方法，以便PC端在浏览器打开公告
      if (!util.isKaisaGlobalPcClient()) {
        return;
      }

      event.preventDefault();
      this.setUrlToKaisaGlobalPcClient(url);
    },
    dataHandleTDX: function dataHandleTDX(data) {
      var _this5 = this;

      // 处理数据 通达信 tdx数据处理
      var obj = {}; // 美股公告

      if (this.type === '2' && this.market === 'U') {
        var noticeList = data.map(function (notice) {
          return notice.ResultSets[0].Content[0];
        });
        var firstNotice = noticeList[0];
        obj.Contents = '';
        obj.Title = firstNotice[0];
        obj.Summary = firstNotice[0];
        obj.Issue_date = firstNotice[1];
        obj.Info_Src = '';
        obj.noticeList = [];
        noticeList.forEach(function (item, index) {
          obj.noticeList.push({
            name: "\u6587\u4EF6".concat(index + 1, "\uFF1A"),
            source: item[3],
            translate: item[4]
          });
        });
        obj.noticeList[0].name = '文件1(主公告)：';
      } else {
        data.ResultSets[0].ColDes.forEach(function (v, k) {
          obj[v.Name] = data.ResultSets[0].Content[0][k];
        });
      }

      this.$nextTick(function () {
        _this5.bindEventListenerKaisaZixunToIndividualSharePage();
      });
      return obj;
    },
    dataHandleZT: function dataHandleZT(data) {
      // 处理数据 智通财经 ZT数据处理
      // 要根据数据拿到四个字段 + 一个Summary分享描述
      var obj = {
        Title: data.title,
        // 标题
        Info_Src: data.sourceCode,
        // 来源
        Issue_date: data.pubDate,
        // 发布时间
        Contents: data.content,
        // 内容 包含图片 应该是个html片段
        Summary: data.title,
        // 分享描述  目前数据没有 所以用title
        Url: data.fileUrl || '' // 附件地址

      };
      return obj;
    },
    dataHandleYQJJ: function dataHandleYQJJ(data) {
      var _this6 = this;

      this.tag = data.eventInfo[0] && data.eventInfo[0].tag;
      this.type = data.eventInfo[0] && data.eventInfo[0].type;

      if (data.contactShares) {
        var marketMap = ['SH', 'SZ', 'HK', 'US'];
        data.contactShares.forEach(function (stock) {
          stock.nowPrice = _this6.toFixed(marketMap[stock.market], stock.nowPrice);
        });
        this.stocks = data.contactShares;
      }

      data.contentInfo = data.contentInfo.replace(/<br>/g, '');
      data.contentInfo = data.contentInfo.replace(/<br \/>/g, '');
      var obj = {
        Title: data.titleInfo,
        Info_Src: data.mediaName,
        Issue_date: data.infoPublTime,
        Contents: data.contentInfo,
        Summary: data.titleInfo
      };
      return obj;
    },
    dataHandleGlobalNews: function dataHandleGlobalNews(data) {
      var _this7 = this;

      var obj = {
        Title: data.title,
        // 标题
        Info_Src: data.media,
        // 来源
        Issue_date: data.pubDate,
        // 发布时间
        Contents: data.content,
        // 内容 包含图片 应该是个html片段
        Summary: data.title,
        // 分享描述  目前数据没有 所以用title
        Url: data.fileUrl || '',
        // 附件地址
        disclaimers: data.disclaimers // 免责声明

      };
      data.stockList.forEach(function (stock) {
        stock.secuAbbr = stock.stockName;
        stock.fullSecuCode = stock.stockCode;
        stock.nowPrice = _this7.toFixed(stock.market, stock.nowPrice);
      });
      this.researchStock = data.stockList || [];
      this.$nextTick(function () {
        _this7.bindEventListenerToIndividualSharePage();
      });
      return obj;
    },
    dataHandleSevenDays: function dataHandleSevenDays(data) {
      this.type = data.attachFile ? '2' : this.type;
      var obj = {
        Title: data.title,
        // 标题
        Info_Src: data.infoSrc,
        // 来源
        Issue_date: data.issueDate,
        // 发布时间
        Contents: data.contents,
        // 内容 包含图片 应该是个html片段
        Summary: data.summary,
        // 分享描述  目前数据没有 所以用title
        Url: data.attachFile || '' // 附件地址

      };
      return obj;
    },
    dataHandleResearchCenter: function dataHandleResearchCenter(data) {
      var title = data.title,
          orgName = data.orgName,
          author = data.author,
          publishDate = data.publishDate,
          abstractText = data.abstractText,
          secCode = data.secCode,
          setCode = data.setCode,
          secName = data.secName,
          market = data.market,
          nowPrice = data.nowPrice,
          changePct = data.changePct;

      if (secName) {
        // 如果有股票名称加入股票列表中，否则会有分隔线样式.stocks::after
        this.researchStock.push({
          stockName: secName,
          stockCode: secCode + '.' + market,
          setCode: setCode,
          nowPrice: this.toFixed(market, nowPrice),
          changePct: changePct
        });
      }

      var obj = {
        Title: title,
        // 标题
        Info_Src: orgName,
        // 来源
        Author: author,
        // 研究员
        Issue_date: publishDate,
        // 发布时间
        Contents: abstractText,
        // 内容 包含图片 应该是个html片段
        Summary: title,
        // 分享描述  目前数据没有 所以用title
        Url: '' // 附件地址

      };
      return obj;
    },
    toFixed: function toFixed(market, price) {
      if (!price || !market) {
        return false;
      }

      var map = {
        'US': 3,
        'HK': 3,
        'SH': 2,
        'SZ': 2
      };
      return price.toFixed(map[market]);
    },
    bindClass: function bindClass() {
      // 给富文本框里的每个img绑定class
      this.imgList = document.getElementsByClassName('zixun-detail-content')[0].getElementsByTagName('img');

      for (var i = 0; i < this.imgList.length; i++) {
        this.imgList[i].setAttribute('class', 'preview-img');
      }
    },
    bindEventListenerToIndividualSharePage: function bindEventListenerToIndividualSharePage() {
      var _this8 = this;

      var stockList = document.getElementsByClassName('insert-stock');
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        var _loop = function _loop() {
          var element = _step.value;
          var stockCode = element.innerText.match(/[(（](.+)[）)]/)[1];
          element.removeAttribute('href');

          if (!_this8.isApp) {
            return "continue";
          }

          (0, _index.queryStockList)(stockCode).then(function (_ref) {
            var body = _ref.body;

            if (body.length === 1) {
              var _body$ = body[0],
                  stockName = _body$.stockName,
                  setCode = _body$.setCode;
              var params = {
                setCode: String(setCode),
                stockCode: stockCode,
                stockName: stockName
              };
              element.addEventListener('click', function () {
                _this8.toIndividualSharePage(params);
              });
            }
          }).catch(function () {});
        };

        for (var _iterator = stockList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ret = _loop();

          if (_ret === "continue") continue;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    bindEventListenerKaisaZixunToIndividualSharePage: function bindEventListenerKaisaZixunToIndividualSharePage() {
      var _this9 = this;

      var stockList = document.getElementsByClassName('insert-stock');
      var pchgList = document.getElementsByClassName('pchg');
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = pchgList[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var element = _step2.value;
          var pchgNumber = element.innerText.match(/\d*/) ? Number(element.innerText.match(/[-]?\d+[.]\d+/)[0]) : '';
          var classNameObject = this.computeClassName(pchgNumber);
          var className = '';

          for (var _i = 0, _Object$keys = Object.keys(classNameObject); _i < _Object$keys.length; _i++) {
            var key = _Object$keys[_i];

            if (classNameObject[key]) {
              className = key;
              break;
            }
          }

          element.classList += " ".concat(className);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        var _loop2 = function _loop2() {
          var element = _step3.value;
          var stockCode = element.innerText.match(/[(（](.+)[）)]/)[1];
          var market = element.dataset.market;

          if (!_this9.isApp) {
            return "continue";
          }

          (0, _index.queryStockList)("".concat(stockCode, ".").concat(market)).then(function (_ref2) {
            var body = _ref2.body;

            if (body.length === 1) {
              var _body$2 = body[0],
                  stockName = _body$2.stockName,
                  setCode = _body$2.setCode;
              var params = {
                setCode: String(setCode),
                stockCode: stockCode,
                stockName: stockName
              };
              element.addEventListener('click', function () {
                _this9.toIndividualSharePage(params);
              });
            }
          }).catch(function () {});
        };

        for (var _iterator3 = stockList[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _ret2 = _loop2();

          if (_ret2 === "continue") continue;
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    },
    computeClassName: function computeClassName(changePct) {
      if (util.isSetGreenColorWhenStockUp()) {
        return {
          'stock-rise-green': changePct > 0,
          'stock-down-red': changePct < 0,
          'stock-zero': changePct === 0
        };
      }

      return {
        'stock-rise-red': changePct > 0,
        'stock-down-green': changePct < 0,
        'stock-zero': changePct === 0
      }; // 默认红涨绿跌
    },
    previewImage: function previewImage(e) {
      // 点击富文本内容 如果是图片则执行预览
      var nowImgurl = e.target.currentSrc;

      if (nowImgurl && e.target.tagName === 'IMG') {
        for (var i = 0; i < this.imgList.length; i++) {
          if (this.imgList[i].currentSrc === nowImgurl) {
            return this.show(i);
          }
        }
      }
    },
    show: function show(index) {
      var _this10 = this;

      // 点击图片获取打开相应图片预览的方法
      this.previewlist = [];

      var _loop3 = function _loop3(i) {
        // 获取图片实际大小
        var newImage = {};
        var img = new Image();
        img.src = _this10.imgList[i].src;

        img.onload = function () {
          newImage.src = img.src;
          newImage.w = img.width;
          newImage.h = img.height;
        };

        _this10.previewlist.push(newImage);
      };

      for (var i = 0; i < this.imgList.length; i++) {
        _loop3(i);
      }

      setTimeout(function () {
        _this10.$preview.open(index, _this10.previewlist); // 调用图片预览方法

      }, 0);
    },
    decreaseFontSize: function decreaseFontSize() {
      var _this11 = this;

      this.$nextTick(function () {
        _this11.$refs.zixunDetailTitle.style.fontSize = '0.4rem';
        _this11.$refs.zixunDetailParams.style.fontSize = '0.26rem';
        _this11.$refs.zixunDetailWrap.style.fontSize = '0.36rem';
        _this11.$refs.zixunTag.style.fontSize = '0.26rem';
      });
    },
    recoverFontSize: function recoverFontSize() {
      var _this12 = this;

      this.$nextTick(function () {
        _this12.$refs.zixunDetailTitle.style.fontSize = '0.48rem';
        _this12.$refs.zixunDetailParams.style.fontSize = '0.32rem';
        _this12.$refs.zixunDetailWrap.style.fontSize = '0.44rem';
        _this12.$refs.zixunTag.style.fontSize = '0.32rem';
      });
    },
    toggleFontSize: function toggleFontSize(fontType) {
      if (fontType === 'small') {
        this.decreaseFontSize();
      } else {
        this.recoverFontSize();
      }
    },
    // 注册js方法供OC调用
    init: function init() {
      var self = this; // 给原生注册方法，供原生调用

      if ((0, util.getIsAppClient)() && isiOS) {
        (0, _initJsBridge.default)(function () {
          // 通过JsBridge调用原生方法，写法固定，第一个参数时方法名，第二个参数时传入参数，第三个参数时响应回调
          window.WKWebViewJavascriptBridge.registerHandler('toggleFontSize', function (response) {
            self.toggleFontSize(response);
          });
        });
      }

      if ((0, util.getIsAppClient)() && isAndroid) {
        // 注册 javascript API
        _dsbridge.default.register('toggleFontSize', function (type) {
          self.toggleFontSize(type);
        });
      }
    },
    openApp: function openApp() {
      this.$router.push({
        name: 'OpenInBrowser',
        query: {
          path: window.location.href
        }
      });
    },
    setUrlToKaisaGlobalPcClient: function setUrlToKaisaGlobalPcClient(url) {
      /**
       * PC端存在以下问题：
       * 打开PDF文件会触发多个下载事件并在浏览器打开多个重复文件；
       * 公告文件是一个HTML网页链接时，会在PC端自身窗口打开而没有返回按钮（因此需要协助PC端在浏览器中打开公告文件）。
       * 针对PC端的定制交互操作：当用户点击查看附件或公告时，调用PC端setUrl方法向其返回一个Url后交由PC端处理
       */
      this.$qtBridge.setUrl(url);
    },
    recordUserVisitedCount: function recordUserVisitedCount() {
      // 记录用户阅读资讯的数量
      if (this.isApp) {
        if (isAndroid) {
          _dsbridge.default.call('nativeReadData', {
            name: 'token'
          }, function (token) {
            console.log('token', token);

            if (token !== '-1') {
              (0, _index.recordUserVisitedCount)(token, 'R3') // R3代表阅读资讯
              .then(function () {}).catch(function () {});
            }
          });
        } else if (isiOS) {
          (0, _initJsBridge.default)(function () {
            window.WKWebViewJavascriptBridge.callHandler('nativeReadData', {
              name: 'token'
            }, function (token) {
              console.log('token', token);

              if (token !== '-1') {
                (0, _index.recordUserVisitedCount)(token, 'R3') // R3代表阅读资讯
                .then(function () {}).catch(function () {});
              }
            });
          });
        }
      }
    }
  }
};
exports.default = _default;